import { useQuery } from "@tanstack/react-query"
import Api from "utils/api/Api"
import { Loading } from "./components/Loading";

export const ByeBye = () => {
    const { data: stat, isLoading, isSuccess } = useQuery({
        queryKey: ['totalStat'],
        queryFn: () => Api.get('/api/statistic/total')
    });

    if (isLoading) return <Loading />;

    const statObj = stat.data?.reduce((newObj, obj) => {
        newObj[obj.name] = obj.value;
        return newObj;
    }, {});



    return (
        <div className="byebyePage">
            {isSuccess &&
                <div className="user_stanby bye">
                    <div className={`container`}>
                        <h2 className="user_stanby_title">독서길라잡이</h2>
                        <p className="user_stanby_desc">
                            갑자기 헤어지게 되어 너무 슬프지만, 언젠가 열심히 살아가다보면

                            다시 만날 날이 있을 거라 생각합니다.

                            많은 일이 있었고, 착하고 다정한 어린이들 덕에 힐링도 된

                            독서길라잡이 운영진 활동이었습니다.

                            경남의 어린이들이 항상 건강하고 책과 함께 하는 바른 생활을 응원할께요~

                            사랑합니다.(❁´◡`❁)(❁´◡`❁)
                        </p>
                        <div className="contents">
                            <div className="hand"></div>
                            <div className="byebyeScreen">
                                <div class="fade"></div>
                                <section class="star-wars">
                                    <div class="crawl">
                                        <div class="title">
                                            <h1>독서길라잡이</h1>
                                            <p>누적활동 </p>
                                        </div>
                                        <div>회원: {statObj.TOTAL_JOIN.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 명</div>
                                        <div>로그인: {statObj.TOTAL_LOGIN.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 회</div>
                                        <hr />
                                        <div>독서력진단: {(statObj.TOTAL_TEST + statObj.TOTAL_CAT).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 회</div>
                                        <hr />
                                        <div>독서활동: {statObj.TOTAL_READING.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 회</div>
                                        <hr />
                                        <div>독서토론: {statObj.TOTAL_DISCUSSION.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 회</div>
                                        <div>독서퀴즈: {statObj.TOTAL_QUIZ.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 회</div>
                                        <div>독서감상문: {statObj.TOTAL_REPORT.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 회</div>
                                        <div>독서화: {statObj.TOTAL_PICTURE.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 회</div>
                                        <div>독서사진: {statObj.TOTAL_PICTURE.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 회</div>
                                        <div>독서영상: {statObj.TOTAL_VIDEO.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 회</div>
                                        <div>나도작가다: {statObj.TOTAL_USERBOOK.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 회</div>
                                        <div>작가와 만남: {statObj.TOTAL_MEETING.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 회</div>
                                        <div>동화서당: {statObj.TOTAL_DONGWHA.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 회</div>
                                        <hr />
                                        <div>댓글: {statObj.TOTAL_COMMENT.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 회</div>
                                        <div>좋아요: {statObj.TOTAL_LIKE.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 회</div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}